/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { CHIP_THEME_DEFAULT, ChipList, ChipProps } from '@squiz/sds';
import React, { useMemo, useState } from 'react';

type ThreadTagChipsProps = {
  tags: Array<string> | [];
};

export const ThreadTagChips = (props: ThreadTagChipsProps): JSX.Element => {
  const { tags } = props;
  const [showAll, setShowAllTags] = useState<boolean>(false);

  const chips: Array<ChipProps> = useMemo(() => {
    let tagChips: Array<ChipProps> = tags.map((tag) => {
      return {
        key: tag,
        selected: false,
        text: tag,
        theme: CHIP_THEME_DEFAULT,
        type: 'selection',
      };
    });
    if (!showAll && tagChips.length > 5) {
      tagChips = tagChips.slice(0, 5);
      tagChips.push({
        customClick: () => setShowAllTags(true),
        key: 'more',
        selected: true,
        text: `+${tags.length - 5}`,
        theme: CHIP_THEME_DEFAULT,
        type: 'navigation',
      });
    }
    return tagChips;
  }, [showAll, tags]);

  if (tags && tags.length === 0) {
    return <span>-</span>;
  }

  return (
    <div className="ai_thread_table_chip_list_container">
      <ChipList chips={chips}></ChipList>
    </div>
  );
};
